// src/pages/nascar/CupData.jsx
import NascarData from "./NascarData";
export default function CupData() { return <NascarData series="cup" />; }